export enum DtoCommonDocumentState {
  PreparingDocument = 'PreparingDocument',
  DocumentPrepared = 'DocumentPrepared',
  DocumentProcessed = 'DocumentProcessed',
  ProcessedDocumentRead = 'ProcessedDocumentRead',
  DocumentDisabled = 'DocumentDisabled',
  Finalized = 'Finalized',
}

export enum DtoSignDocumentState {
  DocumentSignStart = 'DocumentSignStart',
  DocumentEnabled = 'DocumentEnabled',
  DocumentLocked = 'DocumentLocked',
  InsertingSignature = 'InsertingSignature',
  BackendProcessing = 'BackendProcessing',
}

export enum DtoConfirmDocumentState {
  DocumentConfirmStart = 'DocumentConfirmStart',
  PreparedDocumentRead = 'PreparedDocumentRead',
}

export enum DtoReadDocumentState {
  DocumentReadStart = 'DocumentReadStart',
}

export type DtoDocumentState =
  | DtoCommonDocumentState
  | DtoSignDocumentState
  | DtoConfirmDocumentState
  | DtoReadDocumentState;
